import React, { createRef, useRef, useState } from "react";
import logo from '../leclab-madrid-vertical.png'
import { useNavigate } from "react-router-dom";
import { sendApplication } from "../services/firebase/firebase";
import { Modal } from "bootstrap";
import { Policy } from "./modals";

const PartnerApplication = () => {

    const [loading, setLoading] = useState(false)
    const [partner, setPartner] = useState({
        firstname: '',
        lastname: '',
        email: '',
        contact: ''
    })

    const [communication, setCommunication] = useState(false)
    const [privacy, setPrivacy] = useState(false)
    const [errors, setErrors] = useState({})

    const navigate = useNavigate()

    const modalRef = createRef()

    const showModal = () => {
        const modalEle = modalRef.current
        const bsModal = new Modal(modalEle, {
            backdrop: false,
            keyboard: false
        })
        bsModal.show()
        return false
    }

    const hideModal = () => {
        const modalEle = modalRef.current
        const bsModal = Modal.getInstance(modalEle)
        bsModal.hide()
    }

    const makeChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        setPartner({ ...partner, [name]: value })
    }

    const handleValidation = () => {
        //  Invalid email
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/.test(partner.email)) {
            setErrors({ ...errors, error: 'Email no válido' })
            return false
        }
        return true
    }

    const doSubmit = (e) => {
        e.preventDefault()
        setLoading(true)
        if (handleValidation() === true) {
            sendApplication(partner)
                .then(response => {
                    setLoading(false)
                    alert(response)
                    navigate("/")
                })
                .catch(error => {
                    setLoading(false)
                    alert('Ha habido un problema procesando su solicitud, intentelo mas tarde. Si el problema persiste, por favor pongase en contacto con socios@leclab.madrid')
                })
        }
    }

    return (
        <div className="auth-wrapper">
            <div className="auth-inner">
                <div className="card-header bg-transparent">
                    <img width="100" className="mb-2" src={logo} />
                    <h3>Solicitud Amigo de Leclab</h3>
                </div>
                <form className="card-body text-start" style={{ height: 'calc(100% - 3.75rem)' }} onSubmit={doSubmit}>
                    <div className="row align-items-center justify-content-between my-3">
                        <div className="col-sm-12 mb-sm-2 col-md-6">
                            <input
                                type="text"
                                className="form-control"
                                name="firstname"
                                value={partner?.firstname}
                                onChange={makeChange}
                                placeholder="Nombre *"
                                required
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-2 col-md-6">
                            <input
                                type="text"
                                className="form-control"
                                name="lastname"
                                value={partner?.lastname}
                                onChange={makeChange}
                                placeholder="Apellidos *"
                                required
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-3">
                            <input
                                type="text"
                                className="form-control"
                                name="email"
                                value={partner?.email}
                                onChange={makeChange}
                                placeholder="Email *"
                                required
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-2">
                            <label className="form-label">Invitado por</label>
                            <input
                                type="text"
                                className="form-control"
                                name="contact"
                                value={partner?.contact}
                                onChange={makeChange}
                                placeholder="Nombre y Apellidos *"
                                required
                            />
                        </div>
                    </div>
                    <div className="mb-3">
                        <div className="form-check">
                            <input type="checkbox" className="form-check-input" checked={communication} onChange={e => setCommunication(!communication)} />
                            <p className="form-check-label text-start">
                                Acepto recibir comunicaciones de Leclab
                            </p>
                        </div>
                        <div className="form-check">
                            <input type="checkbox" className="form-check-input" checked={privacy} onChange={e => setPrivacy(!privacy)} />
                            <p className="form-check-label text-start">
                                He leído y acepto la <span style={{ cursor: 'pointer', color: '#3366BB' }} onClick={() => showModal()}>Politica de Privacidad</span>
                            </p>
                        </div>
                    </div>
                    <div className="w-100">
                        {!loading && <button disabled={!privacy | !communication} type="submit" className="btn btn-login btn-block w-100">Enviar solicitud</button>}
                        {loading &&
                            <button className="btn btn-login btn-block w-100" type="button" disabled>
                                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                Loading...
                            </button>
                        }
                    </div>
                    <Policy ref={modalRef} />
                </form>
                <div className="card-footer bg-transparent h-30">
                    {errors?.error && <p className="text-danger">{errors.error}</p>}
                </div>
                <div className="d-flex justify-content-end align-items-center">
                    <p className="forgot-password">
                        <a href="/">Volver a Login</a>
                    </p>
                </div>
            </div >
        </div >
    )
};

export default PartnerApplication;